import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { DatePicker } from 'syf-component-library/ui/patterns/DatePicker';
const CalendarField = styled(DatePicker) `
  margin-top: ${({ theme }) => theme.spacing.small}px;
`;
const DAY_LABELS = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
];
const COLUMNHEADER_ROLE = 'columnheader';
const ARIA_LABEL = 'aria-label';
const Calendar = ({ endDate, error, excludedDates = [], id, onChange, onBlur, placeholderLabel, required, selectedDate, startDate, setModalIsOpen }) => {
    const calendarRef = useRef(null);
    const applyHeaderRoles = (container) => {
        const monthHeader = container.querySelector('.react-datepicker__current-month');
        if (monthHeader) {
            monthHeader.setAttribute('role', 'heading');
            monthHeader.setAttribute('aria-level', '2');
        }
        const monthContainer = container.querySelector('.react-datepicker__month');
        if (monthContainer) {
            monthContainer.setAttribute('role', 'grid');
            monthContainer.setAttribute('aria-labelledby', 'month-header');
        }
    };
    const applyDayNameRoles = (container) => {
        var _a, _b;
        const firstWeek = container.querySelector('.react-datepicker__week');
        if (!firstWeek)
            return;
        const dayHeaders = firstWeek.querySelectorAll('.react-datepicker__day');
        const firstDayText = (_b = (_a = dayHeaders[0]) === null || _a === void 0 ? void 0 : _a.textContent) === null || _b === void 0 ? void 0 : _b.trim();
        if (firstDayText && Number.isNaN(Number(firstDayText))) {
            dayHeaders.forEach((dayName, index) => {
                dayName.setAttribute('role', COLUMNHEADER_ROLE);
                dayName.setAttribute(ARIA_LABEL, DAY_LABELS[index]);
            });
        }
    };
    const applyWeekRoles = (container) => {
        const weeks = container.querySelectorAll('.react-datepicker__week');
        weeks.forEach(week => {
            week.setAttribute('role', 'row');
        });
    };
    const applyDayRoles = (container, monthHeader) => {
        const days = container.querySelectorAll('.react-datepicker__day');
        days.forEach((day, index) => {
            var _a, _b;
            if (day.getAttribute('role') !== COLUMNHEADER_ROLE) {
                day.setAttribute('role', 'gridcell');
                day.setAttribute('tabindex', index === 0 ? '0' : '-1');
                const dayNumber = day.textContent;
                const isToday = day.classList.contains('react-datepicker__day--today');
                if (dayNumber) {
                    const monthName = ((_a = monthHeader === null || monthHeader === void 0 ? void 0 : monthHeader.textContent) === null || _a === void 0 ? void 0 : _a.split(' ')[0]) || 'Current';
                    const year = ((_b = monthHeader === null || monthHeader === void 0 ? void 0 : monthHeader.textContent) === null || _b === void 0 ? void 0 : _b.split(' ')[1]) || '2025';
                    day.setAttribute(ARIA_LABEL, `${monthName} ${dayNumber}, ${year}`);
                    if (isToday) {
                        day.setAttribute('aria-current', 'date');
                    }
                }
            }
        });
    };
    const applyNavigationRoles = (container) => {
        const prevButton = container.querySelector('.react-datepicker__navigation--previous');
        if (prevButton) {
            prevButton.setAttribute(ARIA_LABEL, 'Previous Month');
        }
        const nextButton = container.querySelector('.react-datepicker__navigation--next');
        if (nextButton) {
            nextButton.setAttribute(ARIA_LABEL, 'Next Month');
        }
    };
    const applyInputRoles = (container) => {
        const input = container.querySelector('input');
        if (input) {
            input.setAttribute('role', 'combobox');
            input.setAttribute('aria-expanded', 'false');
            input.setAttribute('aria-haspopup', 'dialog');
        }
    };
    useEffect(() => {
        const applyAriaRoles = () => {
            if (!calendarRef.current)
                return;
            const container = calendarRef.current;
            const monthHeader = container.querySelector('.react-datepicker__current-month');
            applyHeaderRoles(container);
            applyDayNameRoles(container);
            applyWeekRoles(container);
            applyDayRoles(container, monthHeader);
            applyNavigationRoles(container);
            applyInputRoles(container);
        };
        const timer = setTimeout(applyAriaRoles, 100);
        const observer = new MutationObserver(applyAriaRoles);
        if (calendarRef.current) {
            observer.observe(calendarRef.current, { childList: true, subtree: true });
        }
        return () => {
            clearTimeout(timer);
            observer.disconnect();
        };
    }, []);
    return (_jsx("div", Object.assign({ ref: calendarRef }, { children: _jsx(CalendarField, { onModalChange: setModalIsOpen, endDate: endDate, error: error, excludeDates: excludedDates, handleOnChange: onChange, onBlurHandler: onBlur, idTextField: id, monthsShown: 1, placeholderLabel: placeholderLabel, required: required, selectedDate: selectedDate, startDate: startDate }) })));
};
export default Calendar;
//# sourceMappingURL=index.js.map